import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=0596909a&"
import script from "./Product.js?vue&type=script&lang=js&"
export * from "./Product.js?vue&type=script&lang=js&"
import style0 from "./Product.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports